import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=45c6fabd&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c6fabd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45c6fabd')) {
      api.createRecord('45c6fabd', component.options)
    } else {
      api.reload('45c6fabd', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=45c6fabd&scoped=true&", function () {
      api.rerender('45c6fabd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XfSweHEg8jRA/JS/comp/Accordion.vue"
export default component.exports